import { Component, cloneElement } from 'react';
/**
 * The detect outside click component will trigger a function when someone clicks outside of the child component
 */
class DetectOutsideClick extends Component {
    constructor() {
        super(...arguments);
        this.clickDetector = (event) => {
            const { dataset: { ignoreOutsideClick, ignoreInsideClick }, } = event.target;
            const element = this.element && (this.element.base || this.element);
            if ((element &&
                element.contains &&
                !ignoreOutsideClick &&
                !element.contains(event.target)) ||
                ignoreInsideClick) {
                this.props.onClickOutside();
            }
        };
    }
    componentDidMount() {
        if (this.props.onMount)
            this.props.onMount();
        requestAnimationFrame(() => {
            document.addEventListener('mousedown', this.clickDetector);
        });
    }
    componentWillUnmount() {
        if (this.props.onUnmount)
            this.props.onUnmount();
        document.removeEventListener('mousedown', this.clickDetector);
    }
    render() {
        const { children } = this.props;
        return cloneElement(children, {
            ref: (node) => {
                const { ref } = this.props;
                if (ref)
                    ref(node);
                this.element = node;
            },
        });
    }
}
DetectOutsideClick.defaultProps = {
    onMount: undefined,
    onUnmount: undefined,
};
export default DetectOutsideClick;
